
import { useState, useEffect } from 'react';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);

  // Handle scroll events safely
  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 50);
    window.addEventListener('scroll', handleScroll);
    // Cleanup on unmount
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  // Scroll to the inquiry form with graceful fallback
  const scrollToForm = () => {
    const el = document.getElementById('inquiry-form');
    if (el) {
      el.scrollIntoView({ behavior: 'smooth', block: 'center' });
    } else {
      console.warn('Element with id "inquiry-form" not found.');
    }
  };

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled ? 'bg-white shadow-lg' : 'bg-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto px-6">
        <div className="flex items-center justify-between h-20">
          <a href="/" className="flex items-center gap-3 cursor-pointer">
            <img 
              src="https://static.readdy.ai/image/a9d6aff03562300b57162884cb61551b/aea8bd7be2b5edb3fb17a566ccc28baa.png" 
              alt="BBD Financial Logo"
              className={`h-10 transition-all ${scrolled ? 'brightness-0' : 'brightness-0 invert'}`}
            />
            <span
              className={`text-lg font-bold tracking-tight transition-colors ${
                scrolled ? 'text-gray-900' : 'text-white'
              }`}
            >
              ISO Decline Program
            </span>
          </a>

          <div className="hidden md:flex items-center gap-8">
            <a
              href="#services"
              className={`text-sm font-medium transition-colors cursor-pointer ${
                scrolled
                  ? 'text-gray-700 hover:text-blue-600'
                  : 'text-white/90 hover:text-white'
              }`}
            >
              Services
            </a>
            <a
              href="#how-it-works"
              className={`text-sm font-medium transition-colors cursor-pointer ${
                scrolled
                  ? 'text-gray-700 hover:text-blue-600'
                  : 'text-white/90 hover:text-white'
              }`}
            >
              How It Works
            </a>
            <a
              href="#testimonials"
              className={`text-sm font-medium transition-colors cursor-pointer ${
                scrolled
                  ? 'text-gray-700 hover:text-blue-600'
                  : 'text-white/90 hover:text-white'
              }`}
            >
              Testimonials
            </a>
            <a
              href="#contact"
              className={`text-sm font-medium transition-colors cursor-pointer ${
                scrolled
                  ? 'text-gray-700 hover:text-blue-600'
                  : 'text-white/90 hover:text-white'
              }`}
            >
              Contact
            </a>
            <button
              onClick={scrollToForm}
              className="bg-blue-600 text-white px-6 py-2.5 rounded-lg text-sm font-semibold hover:bg-blue-700 transition-all whitespace-nowrap cursor-pointer"
            >
              Get Started
            </button>
          </div>
        </div>
      </div>
    </nav>
  );
}
